import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { safeJsonParse } from '../../utils/jsonUtils'
import { experimentalStyled as styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import { Button } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Table from '@mui/material/Table'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import axios from '../../api/axios'
import toast from 'react-hot-toast'
import { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import './DashboardNews.css'

const columns = [
   {
      id: 'vehicle',
      label: 'Vehicle',
   },
   {
      id: 'createAt',
      label: 'Date',
   },
   {
      id: 'status',
      label: 'Status',
      align: 'center',
   },
   {
      id: 'action',
      label: 'Files',
      align: 'right',
   },
]
const Item1 = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '24px',
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   border: '1px solid #E4E7EC',
   borderRadius: '10px',
   boxShadow: '0 1px 3px rgba(16,24,40,0.08)',
   color: theme.palette.text.primary,
}))
const Item2 = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '24px',
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   border: '1px solid #E4E7EC',
   borderRadius: '10px',
   boxShadow: '0 1px 3px rgba(16,24,40,0.08)',
   color: theme.palette.text.primary,
}))
const Item3 = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '24px',
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   border: '1px solid #E4E7EC',
   borderRadius: '10px',
   boxShadow: '0 1px 3px rgba(16,24,40,0.08)',
   color: theme.palette.text.primary,
}))

export default function Dashboard() {
   const [account,setAccount] = useState(null);
   const [allData, setAllData] = useState([])
   const [openTime, setOpenTime] = useState('')
   const [closeTime, setCloseTime] = useState('')
   const [creditAmount, setCreditAmount] = useState(0)
   const [description, setDescription] = useState('')


   useEffect(()=>{
      const user = localStorage.getItem('user');
      if(user){
         let parse = safeJsonParse(user);
         setAccount(parse);
      }
   },[]);

   const navigate = useNavigate()
   const customTime = (date) => {
      const d = new Date(date)
      let hour = d.getHours()
      let minute = d.getMinutes()
      if (hour < 10) hour = '0' + hour
      if (minute < 10) minute = '0' + minute
      return `${hour}:${minute}`
   }
   const getDataByFilter = async (id) => {
      try {
         await axios
            .post(`getDataByFilter`, {
               filter: 'all',
               id,
            })
            .then((result) => {
               if (result.data.status) {
                  setAllData(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }
   const getServiceTime = async () => {
      const weekdaylist = [
         'Sunday',
         'Monday',
         'Tuesday',
         'Wednesday',
         'Thursday',
         'Friday',
         'Saturday',
      ]
      const d = new Date()
      const day = weekdaylist[d.getDay()]

      try {
         await axios
            .post(`getServiceTime`, { day })
            .then((result) => {
               if (result.data.status) {
                  if (result.data.data.open === '--:--:--') {
                     setOpenTime('File service is closed')
                     setCloseTime('File service is closed')
                  } else {
                     setOpenTime(customTime(result.data.data.open))
                     setCloseTime(customTime(result.data.data.close))
                  }
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }
   const getSumCredit = async (id) => {
      try {
         await axios
            .post(`getSumCredit`, { id })
            .then((result) => {
               if (result.data.status) {
                  setCreditAmount(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }
   const getContents = async () => {
      try {
         await axios
            .post(`getContents`)
            .then((result) => {
               setDescription(DOMPurify.sanitize(result.data.new))
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
      }
   }

   useEffect(() => {
      if (account) {
         getContents()
         getDataByFilter(account?._id)
         getServiceTime()
         getSumCredit(account?._id)
      }
   }, [account])

   return (
      <Box
         sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: '#F3F6F9',
            overflowY: 'auto',
         }}
      >
         <Box sx={{ mt: '80px' }}>
            <Grid
               container
               spacing={{ xs: 2, md: 3 }}
               columns={{ xs: 4, sm: 8, md: 12 }}
            >
               <Grid item xs={6} sm={4} md={4}>
                  <Item1>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h3 style={{ margin: '0px' }}>Credits</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h2 style={{ margin: '0px' }}>{creditAmount}</h2>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <Button
                           variant="contained"
                           onClick={() => navigate('/buyCredit')}
                        >
                           Buy Now
                        </Button>
                     </Box>
                  </Item1>
               </Grid>
               <Grid item xs={6} sm={4} md={4}>
                  <Item2>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h3 style={{ margin: '0px' }}>Opening Time</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h2 style={{ margin: '0px' }}>{openTime}</h2>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     ></Box>
                  </Item2>
               </Grid>
               <Grid item xs={6} sm={4} md={4}>
                  <Item3>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h3 style={{ margin: '0px' }}>Closing Time</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h2 style={{ margin: '0px' }}>{closeTime}</h2>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     ></Box>
                  </Item3>
               </Grid>
            </Grid>
         </Box>
         <Box sx={{ mt: '30px' }}>
            <Grid
               container
               spacing={{ xs: 2, md: 3 }}
               columns={{ xs: 4, sm: 8, md: 12 }}
            >
               <Grid item xs={12} sm={12} md={12}>
                  <Item2>
                     <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12 }}
                     >
                        <Grid item xs={12} sm={12} md={6}>
                           <Box
                              sx={{
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                              }}
                           >
                              <h3 style={{ margin: '0px' }}>Uploaded Files</h3>
                           </Box>
                           <Box
                              sx={{
                                 marginTop: '20px',
                                 display: 'flex',
                                 height: '300px',
                                 boxSizing: 'border-box',
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 border: '1px dashed #D0D5DD',
                                 borderRadius: '10px',
                                 flexDirection: 'column',
                                 p: '30px',
                                 gap: '10px',
                              }}
                           >
                              <Box>
                                 <CloudUploadIcon
                                    sx={{
                                       color: '#163A5F',
                                       fontSize: '70px',
                                    }}
                                 />
                              </Box>
                              <Box>Click to Upload File</Box>
                              <Box>
                                 <Button
                                    variant="outlined"
                                    sx={{
                                       border: '1px solid #163A5F',
                                       borderRadius: '12px',
                                       color: '#163A5F',
                                    }}
                                    onClick={() => navigate('/upload')}
                                 >
                                    Browse File
                                 </Button>
                              </Box>
                           </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                           <Box
                              sx={{
                                 display: 'flex',
                                 alignItems: 'flex-start',
                                 flexDirection: 'column',
                              }}
                           >
                              <h3 style={{ margin: '0px' }}>Recent Files</h3>
                           </Box>
                           <Box
                              sx={{
                                 marginTop: '20px',
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                                 flexDirection: 'column',
                              }}
                           >
                              {allData.length > 0 ? (
                                 <TableContainer className="recent-files-table"
                                    component={Paper}
                                    style={{
                                       overflowY: 'auto',
                                       overflowX: 'hidden',
                                       height: '300px',
                                       boxSizing: 'border-box',
                                    }}
                                 >
                                    <Table
                                       sx={{ width: '100%' }}
                                       aria-label="simple table"
                                    >
                                       <TableHead>
                                          <TableRow>
                                             {columns.map((column) => (
                                                <TableCell
                                                   key={column.id}
                                                   align={column.align}
                                                   style={{
                                                      minWidth: column.minWidth,
                                                   }}
                                                >
                                                   {column.label}
                                                </TableCell>
                                             ))}
                                          </TableRow>
                                       </TableHead>
                                       <TableBody>
   {allData.map((row) => (
      <TableRow
         key={row._id}
         sx={{
            '&:last-child td, &:last-child th': {
               border: 0,
            },
         }}
      >

         <TableCell component="th" scope="row">

            <Box
               sx={{
                  fontWeight: 600,
                  color: '#172B4D',
                  lineHeight: 1.25,
               }}
            >
               {row.vehicleType}
            </Box>

            <Box
               sx={{
                  mt: 0.4,
                  fontSize: '11px',
                  color: '#667085',
               }}
            >
               Order #{row.orderId}
            </Box>

         </TableCell>


         <TableCell align="left">
            {row.createdAt}
         </TableCell>


         <TableCell align="center">

            <span
               className={
                  row.status === 'Requested' ? 'request-status' :
                  row.status === 'Completed' ? 'success-status' :
                  row.status === 'Cancelled' ? 'cancel-status' :
                  'progress-status'
               }
               onClick={() => navigate('/overview')}
            >
               {row.status}
            </span>

         </TableCell>


         <TableCell align="right">

            <Button
               size="small"
               variant="outlined"
               onClick={() => navigate('/overview')}
               sx={{
                  minWidth: '56px',
                  px: 1,
                  py: 0.5,
                  borderRadius: '7px',
                  borderColor: '#D0D5DD',
                  color: '#163A5F',
                  fontSize: '12px',
                  fontWeight: 600,
                  '&:hover': {
                     borderColor: '#163A5F',
                     bgcolor: '#F8FAFC',
                  },
               }}
            >
               View
            </Button>

         </TableCell>

      </TableRow>
   ))}
</TableBody>
                                    </Table>
                                 </TableContainer>
                              ) : (
                                 <Box
                                    sx={{
                                       display: 'flex',
                                       flexDirection: 'column',
                                       m: '40px',
                                       alignItems: 'center',
                                    }}
                                 >
                                    <InsertDriveFileIcon
                                       sx={{ fontSize: '60px' }}
                                    />
                                    No recent file
                                 </Box>
                              )}
                           </Box>
                        </Grid>
                     </Grid>
                  </Item2>
               </Grid>
            </Grid>
         </Box>
         <Box sx={{ mt: '30px' }}>
            <h2 style={{ color: '#163A5F', margin: '0px' }}>News</h2>
         </Box>
         <Box
            sx={{
               mt: '10px',
               borderTop: '5px solid #163A5F',
               bgcolor: 'white',
               borderBottomRightRadius: '5px',
               borderBottomLeftRadius: '5px',
               overflow: 'auto',
               p: '10px',
               height: '60vh',
            }}
            id='description'
            className="filehub-news-content"
            dangerouslySetInnerHTML={{ __html: description }}
         />
      </Box>
   )
}
